import {Inject, Vue, Prop} from 'vue-property-decorator';
import Component from 'vue-class-component';

@Component({
    props: ['cols', 'name', 'value', 'label', 'validate', 'type', 'min', 'max', 'disabled', 'mask', 'labelCols', 'placeholder', 'formatter', 'tabindex']
})
export default class BaseInput extends Vue {

    @Inject() parentValidator: any;

    @Prop()
    name: any;
    @Prop()
    validate: any;
    @Prop()
    labelCols: any;
    @Prop()
    placeholder: any;
    @Prop()
    formatter: any;
    @Prop()
    tabindex: any;

    lCols: any = this.labelCols ? this.labelCols : 2;

    hasError() {
        //@ts-ignore
        return this.$validator.errors.has(this.name);
    }

    errorMessage() {
        //@ts-ignore
        return this.$validator.errors.first(this.name);
    }

    hasValidation() {
        return this.validate && this.validate.includes('required');
    }

    errorState(name: any) {
        //@ts-ignore
        return this.$validator.errors.has(name) ? false : null;
    }

    protected created() {
        //@ts-ignore
        this.$validator = this.parentValidator;
    }
}
